import React from 'react';

import {SvgProps} from '../../helpers/type';

const Decrease = ({className, onClick, rectangular}: SvgProps): JSX.Element => {
    return !rectangular ? (
        <svg
            className={className}
            onClick={onClick}
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="10" cy="10.5" r="9.5" stroke="#174943" />
            <rect x="6.5" y="9.7002" width="7" height="1.6" fill="#174943" />
        </svg>
    ) : (
        <svg
            className={className}
            onClick={onClick}
            width="20"
            height="20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path stroke="#174943" d="M.5 1.305h18v18H.5z" />
            <path fill="#174943" d="M6 9.805h7v1.6H6z" />
        </svg>
    );
};

export default Decrease;
